// extracted by mini-css-extract-plugin
module.exports = {"Title":"_28r5aTCyv7c-GvBf4pXNXG","List":"_2Yf_v6IXJ_jwRJPtYNEeqj","ListItem":"_1RvCtZPLHf69at23O6HpqF","Day":"_3KXuUufS4jodPHCYP8s-pp","Time":"_1R3IdBWimnEdQlenASkSQe"};